export enum InvestmentAmount {
    TILL25000 = '0 - 25000',
    TILL100000 = '25000 - 100000',
    OVER100000 = '100000 or more'
}
